var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 800 800",
    width: "48px",
    height: "48px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    cx: "50%",
    cy: "50%",
    r: "50%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(200, 150)",
    d: " M45 88.0001C68.5641 88.0001 87.6666 68.8976 87.6666 45.3334C87.6666 21.7693 68.5641 2.66675 45         2.66675C21.4358 2.66675 2.33331 21.7693 2.33331 45.3334C2.33331 68.8976 21.4358 88.0001 45 88.0001Z M2.33331         152H87.6666V418.667H2.33331V152ZM173 253.333V418.667H247.667V269.333C247.667 242.667 263.667 221.333 290.333         221.333C317 221.333 333 248 333 269.333V418.667H407.667V253.333C407.667 221.333 370.333 152 290.333 152C210.333         152 173 221.333 173 253.333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin.3c45dc43.svg";
export { ForwardRef as ReactComponent };